<template>
  <v-col cols="12">
    <v-row>
      <v-col cols="6">
        <h3>URL of the landing page</h3>
        <v-text-field
          placeholder="https://www.democrats.org/"
          v-model="url"
          @input="scrapUrl"
          prepend-icon="link"
        />
        <v-col cols="12">
        <h3>Ad Video</h3>
          <!-- <div
            class="input-file-block" v-ripple="{ class: 'white--text' }">
            <v-btn large color="primary">
              <v-icon left dark>movie</v-icon>
              Upload Video
            </v-btn>
            <input
              type="file"
              ref="file"
              @change="uploadFile"
            />
          </div> -->
          <div class="input-file-block" v-ripple="{ class: 'white--text' }">
            <v-btn
              @click="selectFileDialog = true"
              large color="primary">
              <v-icon left dark>video_library</v-icon>
              Select a Video
            </v-btn>
          </div>
          <dialog-select-video
            :dialog="selectFileDialog"
            @closeDialog="closeDialog"
          />
      </v-col>
      </v-col>
      <v-col cols="6">
        <v-card
          text
          color="grey lighten-4"
        >
          <v-card-text>
            <div class="caption mb-2">
              <div class="text-uppercase grey--text darken-4">Video recommendations:</div>
              <div>Recommended Length: <strong>Up to 15 seconds</strong></div>
              <div>Recommended Aspect ratio: <strong>Vertical (4:5)</strong></div>
              <div><a href="#">View aspect ratio specifications</a></div>
              <div>Sound: <strong>Enabled with captions included</strong></div>
            </div>
            <div class="caption">
              <div class="text-uppercase grey--text darken-4">Video specifications:</div>
              <div>Recommended format: <strong>.mp4, .mov or .gif</strong></div>
              <div class="mb-1"><a href="#">View full list of supported formats</a></div>
              <div>Required Lengths By Placement:</div>
              <div class="pl-2 mb-1">
                <div>Facebook: <strong>240 minutes max</strong></div>
                <div>In-Stream: <strong>5 - 15 seconds</strong></div>
              </div>
              <div>Resolution: <strong>600px minimum width</strong></div>
              <div>File size: <strong>Up to 4 GB max</strong></div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <transition name="component-fade" mode="out-in">
      <div class="preview-img" v-if="reviewFileUrl">
        <img
          :src="reviewFileUrl"
          width="100%"
          height="100%"
        />
        <v-btn
          small
          absolute
          right
          top
          icon
          dark
          color="grey"
          @click="clearReviewFileUrl"
        >
          <v-icon small>close</v-icon>
        </v-btn>
      </div>
    </transition>
  </v-col>
</template>

<script>
import { mapActions } from 'vuex'
import Scraper from '../../../../../scraper'
import DialogSelectVideo from './helpers/DialogSelectVideo'
export default {
  name: 'upload-image-uploading-block',
  components: {DialogSelectVideo},
  data () {
    return {
      url: 'https://www.democrats.org/',
      timeout: null,
      selectFileDialog: false
    }
  },
  props: {
    reviewFileUrl: {
      type: String,
      default: null
    }
  },
  created () {
    const scraper = new Scraper(this.url)
    scraper.getContent()
  },
  methods: {
    uploadFile () {
      const file = this.$refs.file.files[0]
      let allowFileTypes = ['image/gif', 'video/mp4', 'video/mov', 'video/gif']
      if (!allowFileTypes.find(type => type === file.type)) {
        this.showNotification({
          type: 'warning',
          message: ['Next file types allowed: .mp4, .mov .gif']
        })
        return false
      }
      return new Promise(resolve => {
        resolve(this.$store.dispatch('uploadVideo', file))
      })
        .then(res => console.log(res, 'component'))
    },
    closeDialog (video, reloading) {
      this.selectFileDialog = false
      if (reloading) this.$emit('setMessageFields', video, 'selectedVideo', true)
    },
    clearReviewFileUrl () {
      const file = this.$refs.file
      file.type = 'text'
      file.type = 'file'
      this.$emit('clearReviewFileUrl')
    },
    scrapUrl () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        const regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/
        if (regex.test(this.url)) {
          this.$emit('setMessageFields', this.url, 'url')
          let scraper = new Scraper(this.url)
          scraper.getContent()
        } else {
          this.showNotification({
            type: 'warning',
            message: ['Please type a valid URL']
          })
        }
      }, 1000)
    },
    ...mapActions([
      'showNotification'
    ])
  }
}
</script>
